import { Modal, notification } from "antd";
import useFetchMataData from "../../../../../../Components/Hooks/useFetchMataData";
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from 'yup';
import axiosInstance from "../../../../../../Services/axiosCommon";
import { CancelButton, SubmitButton } from "../../../../../../Components/Utils/Buttons";
import { NuInput, NuSelect, NuTextArea } from "../../../../../../Components/Utils/Input";
import FormikSelectTwo from "../../../../../../Components/Utils/Select";
import DropDownAdd from "../../../../../../Components/Utils/selectAdd";
import UseCatSubCatDropDown from "../../../../../../Components/Hooks/useCategoryDropDown";


function CreateSubEquipment({open,onCancel,getData,itId,projectId,Unit,Type,Activity}) {
 


// const {value:Unit ,getData:refManPowerUnit} = useFetchMataData(`/dropdown/dropdown-details/`,'ManPowerUnit')

  const [api, contextHolder] = notification.useNotification();
  const [isLoading,setIsLoading] = useState(false);
  const [createNew, setCreateNew] = useState({

  projectId:"",
  title_id:"",
  item:"",
  unit:"",
  type:"",
  quantity:"",
  unitPrice:"",
  totalPrice:"",

           
  });
// console.log(projectId,"probjnj");

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema:yup.object({
      item:yup.string().required("Designation Name is Requried")
    }),
    onSubmit: (value,{resetForm}) => {    
      setIsLoading(true);
      const values = {
        ...value,
        projectId: Number(projectId),
        title_id: itId,
        
      }
      axiosInstance
      .post(`/budget-equipment/single-equip`, values)
        .then((res) => {
          console.log(res);
          if (res.status === 201 || res.data.status == true) {
            setIsLoading(false);
            getData();
            resetForm();
            api.success({
              message: `Equipment Item Creation successfully`,
              item: res?.data?.msg || "Added In Tittle",
              placement: "bottomRight",
            });
            onCancel();
          } else {
            api.error({
              message: `Equipment Item  Creation failed`,
              item: res?.data?.msg || "Network error",
              placement: "bottomRight",
            });
            setIsLoading(false);
          }
        })
        .catch((err) => {
          api.error({
            message: `Equipment Item Creation failed`,
            item: err?.data?.msg || "Sever error (or) Network error",
            placement: "bottomRight",
          });
          setIsLoading(false);
        });
    },
  });

  
   useEffect(() => {
     const totalPrice = formik?.values?.quantity * formik?.values?.unitPrice
     formik.setFieldValue("totalPrice", totalPrice);
   }, [formik?.values?.quantity,formik?.values?.unitPrice]);

  return (
    <>
    {contextHolder}
    <Modal
      open={open}
      title={"Create Equipments"}
      width={"50%"}
      className="my-modal"
      centered
      footer={[]}
      onCancel={onCancel}
    >
    <form onSubmit={formik.handleSubmit} >
      <div className=" w-full flex flex-wrap">
      <FormikSelectTwo
           
           label="Item"
           placeholder="Item"
           formik={formik}
           name="item"
           
           isRequired={true}
           Options={Activity}
           width="w-full"               
            
       />
             <FormikSelectTwo
          label="Type"
          width="w-full md:w-1/2"    
          formik={formik}
          placeholder="Choose"
          name="type"
          Options={Type}
          />
      
           <FormikSelectTwo
          label="Unit"
          width="w-full md:w-1/2"    
          formik={formik}
          placeholder="Choose"
          name="unit"
          Options={Unit}
          />
            
           <NuInput
              type="number"
              label=" Quantity"
              placeholder=" Quantity"
              formik={formik}
              name="quantity"
              width="w-full md:w-1/2"
            />
            <NuInput
                         type="number"

              label="UnitPrice"
              placeholder="unitPrice"
              formik={formik}
              name="unitPrice"
              width="w-full md:w-1/2"
            />
            <NuInput
                         type="number"

              label="TotalPrice"
              placeholder="totalPrice"
              formik={formik}
              name="totalPrice"
              width="w-full md:w-1/2"
              disabled={true}
            />
       
            <div className="w-full flex justify-end item-end float-right mx-auto md:mx-0 gap-2 mt-2 md:mr-4">
              <CancelButton handleClick={onCancel} />
              <SubmitButton isLoading={isLoading} />
            </div>
      </div>
      </form>
    </Modal>
    </>
  )
}

export default CreateSubEquipment